export interface AuditDetails {
  terms: {
    viewedTimestamp: string;
    checkedTimestamp: string;
    method: string;
    url: string;
    accepted: boolean;
    version: string;
  };
  privacy: {
    viewedTimestamp: string;
    checkedTimestamp: string;
    method: string;
    url: string;
    accepted: boolean;
    version: string;
  };
}

export interface CompanyDetails {
  name: string;
  number: string;
  type: string;
  companyStatus: string;
}

export interface CompanySearchResponse {
  code: number;
  status: string;
  data: CompanyDetails[];
}

export interface CompanyPersonnel {
  title: string;
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
  jobTitle: string;
  utmSource: string;
  contactSource: string;
}

export interface CompanyPersonnelResponse {
  code: number;
  status: string;
  data: CompanyPersonnel[];
}

export enum LoginType {
  EMAIL_MAGIC_LINK = 'EMAIL_MAGIC_LINK',
  EMAIL_OTP = 'EMAIL_OTP',
  EMAIL_LINK_AND_OTP = 'EMAIL_LINK_AND_OTP',
  UNVERIFIED = 'UNVERIFIED',
  BYPASS_EMAIL_VERIFICATION = 'BYPASS_EMAIL_VERIFICATION'
}

// export interface AddressLine {
//   addressId: string;
//   addressAsLine: string;
// }

// export interface MeterDetails {
//   mpanCore: string;
//   meterType?: string;
//   dataType?: string;
// }
